import { useState } from "react";

import { Button, Drawer, Hairline, Input, Label, Loading } from "@components";

import { Folder } from "@core/Folder";
import styles from "@styles/containers/flows/CreateFolderDrawer.module.scss";
import { If } from "shared/components/control-statements";
import { OlgaEnvironmentsAPI } from "../../../../../providers/OlgaEnvironmentsAPI";

export default function CreateFolderDrawer({
  folders,
  visible,
  onClose,
  onRemove,
  onUpdateFolders,
  onAddFolders,
  loading,
}) {
  const [folderName, setFolderName] = useState("");
  const [saving, setSaving] = useState(false);

  const addFolder = () => {
    if (folderName.length === 0) return;

    const existingFolder = folders.find(
      (existingFolder) => existingFolder.name === folderName
    );

    if (!existingFolder) {
      const folder = new Folder({ name: folderName });
      onUpdateFolders([folder, ...folders]);
    }

    setFolderName("");
  };

  const removeFolder = (folder) => {
    if (folder.isNew) {
      onUpdateFolders(
        folders.filter((currentFolder) => currentFolder.id != folder.id)
      );
    } else {
      onRemove(folder);
    }
  };

  const saveFolders = async () => {
    setSaving(true);

    const currentFolders = await getFolders();
    const newFolders = folders.filter((folder) => folder.isNew);
    const updatedFolders = [...newFolders, ...currentFolders];

    const saveReq = await OlgaEnvironmentsAPI.putConfigurations({
      flow_folders: updatedFolders,
    });

    if (saveReq.getErrors([]).length > 0) {
      alert({ text: saveReq.getErrors()[0] });
    } else {
      onAddFolders();
    }

    setSaving(false);
  };

  const getFolders = async () => {
    const environmentConfigurations =
      await OlgaEnvironmentsAPI.getConfigurations();
    return environmentConfigurations.getData({})?.flow_folders || [];
  };

  return (
    <Drawer onClose={onClose} title="Pastas" visible={visible}>
      <div className={styles.createFolder}>
        <Label>Insira o nome da nova pasta</Label>
        <Input
          placeholder="Nome da pasta"
          onChange={(text) => setFolderName(text.target.value)}
          value={folderName}
        />
        <Button
          design="default-2"
          className="mt-15 w-100"
          onClick={addFolder}
          disabled={!folderName}
        >
          Adicionar
        </Button>

        <Hairline solid className="mt-30 mb-30" />

        <Label>Pastas ({folders.length})</Label>

        <If cond={loading}>
          <div className={styles.folders}>
            <div className="h-100 d-flex align-center justify-center">
              <Loading />
            </div>
          </div>
        </If>
        <If cond={!loading}>
          {folders.length === 0 ? (
            <div className={styles.empty}>
              <div className={styles.icon}>
                <i className="fal fa-folder-open" />
              </div>

              <p>Não há pastas criadas no momento.</p>
              <span>
                Por meio desta ferramenta, será possível organizar os seus
                fluxos por pastas.
              </span>
            </div>
          ) : (
            <div className={styles.folders}>
              {folders.map((folder) => (
                <div className={styles.folder} key={folder.id}>
                  <p>{folder.name}</p>
                  <div
                    className={styles.remove}
                    onClick={() => removeFolder(folder)}
                  >
                    <i className="far fa-times" />
                  </div>
                </div>
              ))}
            </div>
          )}
        </If>

        <div className={styles.footer}>
          <Button
            className="w-100"
            design="primary"
            onClick={saveFolders}
            disabled={saving}
            loading={saving}
          >
            Salvar
          </Button>
        </div>
      </div>
    </Drawer>
  );
}
